import { RouterModule } from '@angular/router';
import { TemplatesComponent } from './templates.component';
import { TemplatesModalComponent } from './modals/templates-modal.component';

const modalRoute = [
    {
        path: 'edit/:id/:languageCode/:clinicId', component: TemplatesModalComponent,
        data: {
            type: 'read'
        }
    }
];

export const TemplatesRoutesModule = RouterModule.forChild([
    {
        path: '',
        component: TemplatesComponent,
        data: {
            alias: 'templates.index',
            reload: false,
        },
        children: modalRoute
    },
    {
        path: 'clinic/:clinicId',
        component: TemplatesComponent,
        data: {
            alias: 'templates.clinic.index',
            reload: false
        },
        children: modalRoute
    }
]);
